/**
未适配，暂时只支持品牌广告使用
*/
<template>
  <div class="gj-upload" :class="{'gj-upload-cannot-delete': !deletable}">
    <el-upload
        ref="gjUploadVidel"
        v-bind="$attrs"
        v-on="$listeners"
        :disabled="uploadStatus != 0"
        :before-upload="proxyBeforeUpload"
        :http-request="customUpload"
        :file-list="proxyFileList"
        :show-file-list="false"
        action="">
        <slot>
          <gj-button type="primary" :disabled="uploadStatus != 0">上传视频</gj-button>
        </slot>
    </el-upload>
    <div v-if="file && [2,3].includes(uploadStatus)" class="file-class">
      <el-row type="flex" justify="space-between">
        <div class="play" :class="{f00: uploadStatus == 2}">
          <i class="el-icon-video-play"></i>
          <span>{{ file.name }}</span>
          <span v-if="uploadStatus == 3" class="c6">时长：{{ this.form.videoInfo.duration }}s</span>
          <span v-if="uploadStatus == 3" class="c6">大小：{{ this.form.videoInfo.size }}M</span>
        </div>
        <div class="delete">
          <i class="el-icon-delete" @click="deleteFile"></i>
        </div>
        <div v-if="uploadStatus == 2" class="outline">
          <i class="el-icon-warning-outline"></i>
          <span>上传失败</span>
        </div>
        <div v-else-if="uploadStatus == 3" class="check">
          <i class="el-icon-circle-check"></i>
          <span>上传成功</span>
        </div>
      </el-row>
      <div class="details" v-if="uploadStatus == 3">
        <span class="details-cell">时长：{{ this.form.videoInfo.duration }}s</span>
        <span class="details-cell">大小：{{ this.form.videoInfo.size }}M</span>
      </div>
    </div>
    <el-progress v-if="uploadStatus == 1" :percentage="progressPercent" style="margin-top: 24px"></el-progress>
  </div>
</template>

<script>
  import { removeAttachmentById, uploadFileVideo } from "@/api/common";
  import { adStore } from "modules/ad/common/store";
  import { isMeaningfulMixin } from "@/minxins";
  import { isMeaningful } from "@/utils/common";
  import { uploadVideo, pollingDescribe } from "@/api/ad"
  export default {
    name: "gj-upload-video",
    mixins: [isMeaningfulMixin],
    props: {
      text: {
        type: String,
        default: '上传附件'
      },
      deletable: {
        type: Boolean,
        default: true
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      acceptType: {
        type: Array,
        default: () => []
      },
      containerType: {
        type: String,
        default: '',
      },
      containerBizId: {
        default: null
      },
      fileList: {
        type: Array,
        default: () => []
      },
      beforeUpload: {
        type: Function,
        default: null
      },
      // 参数
      params: {
        default: ()=> ({})
      },
      form: {
        default: ()=> ({})
      }
    },
    watch: {
      fileList: {
        deep: true,  // 深度监听
        handler(newVal, oldVal) {
          this.proxyFileList = newVal;
          if (isMeaningful(oldVal) && isMeaningful(newVal) && oldVal.length > newVal.length) {
            const newIds = newVal.map(v => v.attId);
            this.removeFile(oldVal.filter(v => newIds.indexOf(v.attId) === -1)[0].attId)
          }
        }
      }
    },
    created() {
      this.proxyFileList = this.fileList;
    },
    data() {
      return {
        adStore,
        setTime: null,
        progressPercent: 0, // 进度条
        loading: false,
        file: null, // 文件类型
        proxyFileList: [],
        uploadStatus: 0, // 上传状态 0：还未上传、 1：上传中、 2：上传失败、 3：上传成功
      }
    },
    methods: {
      // 删除视频
      deleteFile() {
        this.uploadStatus = 0;
        this.file = null;
        this.proxyFileList = [];
        this.form.videoInfo.publishedMediaUrl = null
        this.form.videoInfo.duration = null
        this.form.videoInfo.size = null
        this.$emit('update:fileList', this.proxyFileList);
      },
      // 获取视频时长大小
      getVideoInfo(file) {
        //获取视频或者音频时长
        var fileurl = URL.createObjectURL(file);
        //经测试，发现audio也可获取视频的时长
        var audioElement = new Audio(fileurl);
        var duration;
        let _this = this
        audioElement.addEventListener("loadedmetadata", function (_event) {
            duration = audioElement.duration;
            _this.form.videoInfo.duration = Math.floor(duration)
        });
        //获取文件大小
        var size = this._.floor(file.size / 1024 / 1024, 2);//单位：字节(byte)
        this.form.videoInfo.size = size

      },
      proxyBeforeUpload(file) {
        if (this.beforeUpload) {
          const valid = this.beforeUpload();
          if (!valid) return false;
        }
        if (this.acceptType.length > 0 && this.acceptType.indexOf(file.type) === -1) {
          this.$gjMessage.error('无法接受的文件类型');
          return false;
        }
        this.file = file
        return true;
      },
      async customUpload(data) {
        this.progressPercent = 0
        this.uploadStatus = 1
        let formData = new FormData();
        formData.append('file', data.file);
        formData.append('marketId', this.params.marketId);
        this.setTime = setInterval(() => {
          this.progressPercent >= 98 ? clearInterval(this.setTime) : this.progressPercent++
        }, 321);
        try {
          let res = await uploadVideo(formData)
          if (res.code != 0) {
            this.uploadStatus = 2
            return this.$gjMessage.error('上传文件失败，请稍后再试') 
          }
          this.getVideoInfo(data.file) 
          this.pollingDescribe(this.adStore.SB.marketId , res.data.mediaId)
          this.form.videoMediaIds = [res.data.mediaId]
          // this.proxyFileList.push({attId: res.data.id, name: data.file.name});
          // this.$emit('update:fileList', this.proxyFileList);
        } catch (error) {
          clearInterval(this.setTime)
          this.progressPercent = 100
          this.uploadStatus = 2
        }
      },
      // 根据id获取视频url
      pollingDescribe (marketId, mediaId) {
        setTimeout(async () => {
          try {
            let { data } = await pollingDescribe({marketId, mediaId})
            const status = {
              // 上传中
              Processing: () => {
                this.pollingDescribe(marketId, mediaId)
              },
              // 验证中
              PendingDeepValidation: () => {
                this.pollingDescribe(marketId, mediaId)
              },
              // 可用
              Available: () => {
                clearTimeout(this.setTime)
                this.form.videoInfo.publishedMediaUrl = data.publishedMediaUrl
                this.progressPercent = 100
                this.uploadStatus = 3
                this.$gjMessage.success("上传成功")
              },
              // 失败
              Failed: () => {
                clearTimeout(this.setTime)
                this.progressPercent = 100
                this.uploadStatus = 2
                this.$gjMessage.error(data.statusMetadata.errors[0].message || "视频验证失败")
              },
            }
            status[data.status]()
          } catch (error) {
            clearTimeout(this.setTime)
            this.progressPercent = 100
            this.uploadStatus = 2
          }
        }, 2000);
      },
      removeFile(attId) {
        if (isMeaningful(attId)) {
          removeAttachmentById(attId)
            .then(() => {

            });
        }
      },
    }
  }
</script>

<style scoped lang="scss">
  .f00 {
    color: #f00 !important;
  }
  .file-class {
    margin-top: 6px;
    margin-bottom: 20px;
    line-height: 1;
    padding: 6px;
    font-size: 12px;
    width: 100%;
    transform: translateX(-6px);
    position: relative;
    i {
      font-size: 14px;
      padding-right: 3px;
    }
    .play {
      color: #333;
      span {
        padding-right: 10px;
        &.c6 {
          color: #666;
          padding-right: 5px;
          display: none;
          transform: scale(.9);
        }
      }
    }
    .outline {
      color: #f00;
    }
    .check {
      color: #00B000;
    }
    .delete {
      color: #333;
      cursor: pointer;
      display: none;
    }
    &:hover {
      background: rgba(240,244,248,0.60);
      border-radius: 2px;
      .delete {
        display: block;
      }
      .c6  {
        display: inline-block !important;
      }
      .details {
        .details-cell {
          display: none;
        }
      }
      .outline, .check {
        display: none;
      }
    }
    .details {
      width: 250px;
      height: 45px;
      line-height: 45px;
      // background: aquamarine;
      transform: scale(.9);
      position: absolute;
      bottom: -30px;
      left: 16px;
      font-size: 12px;
      color: #666;
      cursor: default;
      span {
        padding-right: 17px;
      }
    }
  }
  .gj-upload {
    flex: 1;
  }
  .gj-image-uploader /deep/ .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    box-sizing: border-box;
  }

  .gj-image-uploader /deep/ .el-upload:hover {
    border-color: #1F6EEF;
  }

  /deep/ .el-upload-list__item-name {
    padding-left: 0;
  }
  .gj-upload-cannot-delete /deep/ .el-icon-close-tip,
  .gj-upload-cannot-delete /deep/ .el-icon-close,
  .gj-upload-cannot-delete /deep/ .el-upload-list__item-status-label {
    display: none;
  }
  /deep/.el-progress-bar {
    padding-right: 0;
  }
  /deep/.el-progress__text {
    position: absolute;
    right: 0;
    top: -21px;
    font-size: 12px !important;
    color: #1F6EEF;
  }
</style>
